<template>
  <div class="dropdown"
       :id="`dataDropdownContainer${cloneId}`"
       @click.middle="$emit('onMiddleClick')"
  >
    <button
        :class="buttonClass"
        :style="buttonStyle"
        :id="`dataDropdown${cloneId}`" role="button"
        :data-toggle="`${openInHover?null:'dropdown'}`"
        aria-haspopup="true"
        aria-expanded="false"
        @click.prevent="onClick"
        @mouseover="setHover(true)"
        @mouseleave="setHover(false)"
    >
      <slot name="button" :list="list"></slot>
    </button>
    <div class="dropdown-menu" :id="`dataDropdownMenu${cloneId}`" :style="contentStyle" :class="contentClass"
         :aria-labelledby="`dataDropdown${cloneId}`" v-if="openInClick"
         @mouseover="MenuHover = true"
         @mouseleave="MenuHover = false"
    >
      <slot name="content" :list="list"></slot>
    </div>
  </div>
</template>


<script>
import Vuex from 'vuex'

export default {
  name: 'data-dropdown',
  props: {
    openInClick: {
      type: Boolean,
      default: true,
    },
    openInHover: {
      type: Boolean,
      default: false,
    },
    buttonStyle: {},
    buttonClass: {
      type: Array,
      default: () => []
    },
    contentStyle: {},
    contentClass: {
      type: Array,
      default: () => []
    },
    id: {
      default: null
    },
    dataProvider: {
      required: false,
      default: null
    },
    resultSet: {
      required: false,
      default: null
    },
    defaultList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    setHover(hoverstate) {
      this.hover = hoverstate;
      if (this.hover) {
        this.$emit('onHover');
      }
    },
    onClick: function () {
      this.$emit('onClick', this);
      if (!this.isVisible && this.isVisibleTime === 0) this.isVisibleTime += 1;
      this.isVisible = !this.isVisible;
    },
    close() {
      setTimeout(() => {
        $(`#dataDropdown${this.cloneId}`).dropdown('hide');
        $(`#dataDropdownMenu${this.cloneId}`).removeClass('show');
        $(`#dataDropdownContainer${this.cloneId}`).removeClass('show');
        this.isVisible = false;
      }, 200);
    },
    open() {
      setTimeout(() => {
        $(`#dataDropdown${this.cloneId}`).dropdown('toggle');
        $(`#dataDropdownMenu${this.cloneId}`).addClass('show');
        $(`#dataDropdownContainer${this.cloneId}`).addClass('show');
        this.isVisibleTime += 1;
        this.isVisible = true;
      }, 200);
    }
  },
  watch: {
    hover: function (val) {
      if (this.openInHover) {
        setTimeout(() => {
          if (!val && !this.MenuHover) {
            $(`#dataDropdown${this.cloneId}`).dropdown('hide');
            this.isVisible = false;
          } else {
            $(`#dataDropdown${this.cloneId}`).dropdown('toggle');
            this.isVisibleTime += 1;
            this.isVisible = true;
          }
        }, 100);
      }
    },
    MenuHover: function (val) {
      if (this.openInHover) {
        setTimeout(() => {
          if (!val && !this.hover) {
            $(`#dataDropdown${this.cloneId}`).dropdown('hide');
            this.isVisible = false;
          } else {
            $(`#dataDropdown${this.cloneId}`).dropdown('toggle');
            this.isVisibleTime += 1;
            this.isVisible = true;
          }
        }, 100);
      }
    },
    isVisible: function (val) {
      if (val) {
        this.$emit('isVisible', this);
        if (this.isVisibleTime === 1) this.$emit('isVisibleFirstTime', this);
      }
    }
  },
  computed: {
    list() {
      return this.defaultList.length > 0 ? this.defaultList : this.data_provider_ref ? (!this.resultSet ? this.data_provider_ref.list : this.data_provider_ref.result.list[this.resultSet]) : [];
    },
  },
  mounted() {
    this.cloneId = this.id ? this.id : this._uid;
    $(`#dataDropdown${this.cloneId}`).dropdown();
    this.data_provider_ref = app.dataproviders[this.dataProvider];
  },
  data() {
    return {
      cloneId: null,
      data_provider_ref: {list: []},
      hover: false,
      MenuHover: false,
      isVisible: false,
      isVisibleTime: 0,
    }
  }

}
</script>
